import React from "react";
import parentClasses from "../Buttons.module.scss";
import { NavLink } from "react-router-dom";
import { getIcon } from "../../../helpers";
import * as btnConfig from "../btnsSetup";

const ButtonNavLink = ({
  btnType,
  text,
  size,
  rounded,
  to,
  className = "",
  title = "",
  children,
  icon,
  style = {},
}) => {
  const _btnRoundedClass = rounded ? parentClasses.Rounded : "";
  const _icon = getIcon(icon, parentClasses.Icon);

  // Check the button size
  let btnSizeClass = btnConfig.getBtnSize(size); 

  let btnTypeClass = btnConfig.getBtnTypeClass(btnType);

  const alt = title ? title : text ? text : "";
  return (
    <NavLink
      style={{ fontSize: "inherit", ...style }}
      title={title}
      alt={alt}
      to={to ? to : ""}
      className={`${btnTypeClass} ${btnSizeClass} ${_btnRoundedClass}  ${className}`}
    >
      {_icon}
      {children ? children : text ? text : null}
    </NavLink>
  );
};

export default ButtonNavLink;
